import { MouseEventHandler, PropsWithChildren } from "react";
import { isRelativeUrl } from "~/lib/shared/isRelativeUrl";
import Link from "next/link";

export const CTALink = ({
  children,
  className,
  onClick,
  href,
}: PropsWithChildren<{
  className: string;
  onClick: MouseEventHandler;
  href: string;
}>): JSX.Element =>
  isRelativeUrl(href) ? (
    <Link href={href} onClick={onClick} className={className}>
      {children}
    </Link>
  ) : (
    <a href={href} onClick={onClick} className={className}>
      {children}
    </a>
  );
